import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

export const dropdownsApi = createApi({
    reducerPath: 'dropdownsApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getDropdowns: builder.query({
            query: ({ data, dropdown_group }) => {
                return {
                    url: '/dropdowns/get_dropdown',
                    method: 'POST',
                    body: { 
                        'data': {
                            ...data,
                            ...(data.dropdown_group === undefined && { 'dropdown_group': dropdown_group })
                        }
                    }
                };
            },
        })
    }
    ),
});

export const {
    useGetDropdownsQuery,
    useLazyGetDropdownsQuery
} = dropdownsApi;

export default dropdownsApi.reducer;